import { SupplyItemStatus } from '@caresend/types';
import { nullishFilter } from '@caresend/utils';
import { defineComponent, ref, computed, watch, watchEffect } from 'vue';
import __vue_component__ from '../../../../../itinerary/scanning/MultiSupplyFromListScanner.vue.js';
import { usePortalStore, isRecordManagerWithScannableItems } from '../../../store/portal/index.js';
import { PackingWorkflowItemID } from '../../../store/portal/workflow/items/model.js';
import { useItineraryWorkflowsStore } from '../../../store/portal/workflow/itinerary.js';
import { showIntercomMessenger } from '../../../../../../functions/intercom.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { getSupplyItemsFromItemsToScan } from '../../../../../../functions/supplies/get.js';
import '../../../../../../store/modules/app/model.js';
import 'firebase/auth';
import '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '../../../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import '../../../../../../functions/supplies/scanning.js';
import '../../../../../../store/modules/procedures/model.js';

var script = defineComponent({
    name: 'WorkflowItemScanner',
    components: {
        MultiSupplyFromListScanner: __vue_component__,
    },
    model: {
        prop: 'isScanningCompleted',
        event: 'complete',
    },
    props: {
        actionOnScan: {
            type: String,
            default: null,
        },
        recordManagerID: {
            type: String,
            required: true,
        },
        recordManagerTargetID: {
            type: String,
            required: true,
        },
        workflowItem: {
            type: Object,
            required: true,
        },
        labelTitle: {
            type: String,
            default: undefined,
        },
        offlineMode: {
            type: Boolean,
            default: false,
        },
        expectedSupplyItemStatus: {
            type: String,
            default: SupplyItemStatus.ACTIVATED,
        },
    },
    emits: ['complete'],
    setup(props, { emit }) {
        const recordManager = usePortalStore()[props.recordManagerID];
        const itineraryWorkflowsStore = useItineraryWorkflowsStore();
        const title = ref();
        const getInitialScannableItems = () => {
            var _a, _b, _c;
            const items = [];
            /** If the record manager has scannable items by workflow item ID, add them */
            if (isRecordManagerWithScannableItems(recordManager)) {
                const scannableItems = recordManager.getters.scannableItemsByWorkflowItemID(props.recordManagerTargetID);
                items.push(...((_b = (_a = scannableItems[props.workflowItem.id]) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []));
                title.value = (_c = scannableItems[props.workflowItem.id]) === null || _c === void 0 ? void 0 : _c.title;
            }
            /** As a default, the initial scannable kit supply is added */
            if (!items.length) {
                items.push(...[recordManager.getters.initialScannableKitSupply(props.recordManagerTargetID, props.offlineMode)]
                    .filter(nullishFilter)
                    .flatMap((item) => item));
                title.value = recordManager.getters.workflowScanTitle(props.recordManagerTargetID);
            }
            /** Override the title if the label title is provided */
            if (props.labelTitle) {
                title.value = props.labelTitle;
            }
            return items;
        };
        const scanningItems = ref(getInitialScannableItems());
        const isOfflineOrNotSupplyKitItem = computed(() => props.workflowItem.id !== PackingWorkflowItemID.SCAN_KIT_SUPPLY_ITEMS ? props.offlineMode : false);
        // Make sure scanningItems is not empty. Otherwise this will just output true
        const isScanningCompleted = ref(false);
        const supplyItems = ref({});
        watch(scanningItems, async (items) => {
            supplyItems.value = await getSupplyItemsFromItemsToScan(items);
            isScanningCompleted.value
                = scanningItems.value.length > 0 && scanningItems.value.every((item) => item.isScanned);
        }, { immediate: true });
        const updateItemsToScan = (items) => {
            scanningItems.value = items;
        };
        const submitSupplies = async () => {
            if (props.actionOnScan) {
                const action = itineraryWorkflowsStore.actions[props.actionOnScan];
                action === null || action === void 0 ? void 0 : action(scanningItems.value, supplyItems.value, props.workflowItem);
            }
            emit('complete');
        };
        watchEffect(() => { if (isScanningCompleted.value)
            submitSupplies(); });
        const workflowItemScanner = ref(null);
        return {
            scanningItems,
            isOfflineOrNotSupplyKitItem,
            updateItemsToScan,
            isScanningCompleted,
            showIntercomMessenger,
            title,
            workflowItemScanner,
        };
    },
});

export { script as default };
